
import * as Paginator from "react-bootstrap-table2-paginator";

import { Button, Card, Col, Form, Modal, Row } from "react-bootstrap";
import { Field, Formik } from "formik";
import React, { useEffect, useState } from "react";
import {
  faDownload,
  faPlus,
  faSearch,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import {
  getCalibrationEntryByDate,
  getCalibrationPdfDownload,
  getFieldWorkOrderDetailsLExcel,
  getFieldWorkOrderDetailsLPdf,
  getFieldWorkOrderExcelDownload,
  getWorkOrderCalibrationList,
  getcalibrationdispensersereialNo,
} from "../../Service/AllWorkOrderCalibrationAPI";
import BootstrapTable from "react-bootstrap-table-next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import Pagination from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import cellEditFactory from "react-bootstrap-table2-editor";
import fileSaver from "file-saver";
import filterFactory from "react-bootstrap-table2-filter";
import moment from "moment";
import swal from "sweetalert";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default () => {
  // --- state ---
  const [entries, setEntries] = useState([]); 
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [isLoaded, setisLoaded] = useState(false);

  const [searchDispenserSerialNumber, setSearchDispenserSerialNumber] = useState("");
  const [searchPerformed, setSearchPerformed] = useState(false);

  // Pagination state
  const [currentPage, setcurrentPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [totaloffset, setTotaloffset] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

 
  const addSerialNumbers = (arr = [], offset = 0) => {
    if (!Array.isArray(arr)) return [];
    return arr.map((item, index) => ({ ...item, id: offset + index + 1 }));
  };

  useEffect(() => {
    // initial load
    getCalibration();
  
  }, []);

 

  const handlePageChange = async (page) => {
   
    const selectedPage = page - 1;
    setEntries([]); 
    setisLoaded(true);

    if (!fromDate && !toDate) {
      try {
        const role = sessionStorage.getItem("role");
        const fkUserId = sessionStorage.getItem("pkUserId");
        const token = sessionStorage.getItem("token");
        const headers = { Authorization: `Bearer ${token}` };

        const result = await getWorkOrderCalibrationList(
          selectedPage,
          "calibration",
          fkUserId,
          role,
          headers
        );

        
        const data = Array.isArray(result) ? result : result?.data?.content || [];
        const totalSize = result?.data?.pageable?.offset || 0;
        const totalElements = result?.data?.totalElements || 0;
        const totalPages = result?.data?.totalPages || 0;

        if (data.length > 0) {
          const updated = addSerialNumbers(data, totalSize);
          setEntries(updated);
          setPageCount(totalPages);
          setTotaloffset(totalSize);
          setTotalCount(totalElements);
        } else {
          setEntries([]);
          setPageCount(0);
          setTotaloffset(0);
          setTotalCount(0);
          // swal("Sorry", "Work order calibration data is not present", "warning");
        }
      } catch (error) {
        console.error("Get Pagination Calibration Error", error);
        // swal("Failed", "Something went wrong while fetching data", "error");
      } finally {
        setisLoaded(false);
        setcurrentPage(selectedPage);
      }
    } else if (fromDate && toDate) {
      try {
        const result = await getCalibrationEntryByDate(
          selectedPage,
          moment(fromDate).format("YYYY-MM-DD"),
          moment(toDate).format("YYYY-MM-DD")
        );

        const data = result?.data?.content || [];
        const totalSize = result?.data?.pageable?.offset || 0;
        const totalElements = result?.data?.totalElements || 0;
        const totalPages = result?.data?.totalPages || 0;

        if (data.length > 0) {
          const updated = addSerialNumbers(data, totalSize);
          setEntries(updated);
          setTotaloffset(totalSize);
          setTotalCount(totalElements);
          setPageCount(totalPages);
        } else {
          setEntries([]);
          setPageCount(0);
          setTotaloffset(0);
          setTotalCount(0);
          swal(
            "Sorry",
            "Work order calibration data is not present for selected date",
            "warning"
          );
        }
      } catch (error) {
        console.error("Get Pagination Date wise Calibration Error", error);
        swal("Failed", "Something went wrong while fetching date-wise data", "error");
      } finally {
        setisLoaded(false);
        setcurrentPage(selectedPage);
      }
    } else {
      setisLoaded(false);
      swal("Failed", "Please select date", "error");
    }
  };

  const getCalibration = async () => {
    try {
      setisLoaded(true);
      const role = sessionStorage.getItem("role");
      const fkUserId = sessionStorage.getItem("pkUserId");
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };

      const result = await getWorkOrderCalibrationList(
        currentPage,
        "calibration",
        fkUserId,
        role,
        headers
      );

      const data = Array.isArray(result) ? result : result?.data?.content || [];
      const totalElements = result?.data?.totalElements || 0;
      const totalPages = result?.data?.totalPages || 0;
      const totalSize = result?.data?.pageable?.offset || 0;

      if (data.length > 0) {
        const updated = addSerialNumbers(data, totalSize);
        setEntries(updated);
        setPageCount(totalPages);
        setTotalCount(totalElements);
        setTotaloffset(totalSize);
      } else {
        setEntries([]);
        setPageCount(0);
        setTotalCount(0);
        setTotaloffset(0);
        // swal("Sorry", "Work order calibration data is not present", "warning");
      }
    } catch (error) {
      console.error("Work Order Calibration Error", error);
      // swal("Failed", "Something went wrong please check your internet", "error");
    } finally {
      setisLoaded(false);
    }
  };

  const getCalibrationListByDate = async () => {
    try {
      setisLoaded(true);
      if (fromDate && toDate) {
        const result = await getCalibrationEntryByDate(
          currentPage,
          moment(fromDate).format("YYYY-MM-DD"),
          moment(toDate).format("YYYY-MM-DD")
        );

        const data = result?.data?.content || [];
        const totalElements = result?.data?.totalElements || 0;
        const totalPages = result?.data?.totalPages || 0;
        const totalSize = result?.data?.pageable?.offset || 0;

        if (data.length > 0) {
          const updated = addSerialNumbers(data, totalSize);
          setEntries(updated);
          setPageCount(totalPages);
          setTotalCount(totalElements);
          setTotaloffset(totalSize);
        
          // setFromDate(null);
          // setToDate(null);
        } else {
          setEntries([]);
          setPageCount(0);
          setTotalCount(0);
          setTotaloffset(0);
          swal(
            "Sorry",
            "Work order calibration data is not present for selected date.",
            "warning"
          );
        }
      } else {
        swal("Failed", "Please select date", "error");
      }
    } catch (error) {
      console.error("Get Dealer Entry Error", error);
      // swal("Failed", "Something went wrong please check your internet", "error");
    } finally {
      setisLoaded(false);
    }
  };

  // ========== Date handlers ==========
  const handleFromDateChange = (date) => {
    setFromDate(date);
    if (toDate && date > toDate) {
      setToDate(null);
    }
  };

  const handleToDateChange = (date) => {
    if (fromDate && date < fromDate) {
      swal('Invalid Date', 'The "To" date cannot be before the "From" date.', 'warning');
      setToDate(null);
    } else {
      setToDate(date);
    }
  };

  // ========== Excel / PDF ==========
  const getFieldWorkOrderExcel = async () => {
    if (fromDate && toDate) {
      try {
        await getFieldWorkOrderExcelDownload(
          moment(fromDate).format("YYYY-MM-DD"),
          moment(toDate).format("YYYY-MM-DD")
        );
      } catch (error) {
        console.error("getFieldWorkOrderExcelDownload error:-", error);
        swal("Failed", "Excel download failed", "error");
      }
    } else {
      try {
        await getFieldWorkOrderDetailsLExcel();
      } catch (error) {
        console.error("getFieldWorkOrderDetailsLExcel Calibration error:-", error);
        swal("Failed", "Excel download failed", "error");
      }
    }
  };

  const getCalibrationReportPdfDownload = async () => {
    if (fromDate && toDate) {
      try {
        setisLoaded(true);
        await getCalibrationPdfDownload(
          moment(fromDate).format("YYYY-MM-DD"),
          moment(toDate).format("YYYY-MM-DD")
        );
      } catch (error) {
        console.error("getCalibrationPdfDownload error:", error);
        // swal("Failed", "Something went wrong please check your internet", "error");
      } finally {
        setisLoaded(false);
      }
    } else {
      try {
        setisLoaded(true);
        await getFieldWorkOrderDetailsLPdf();
      } catch (error) {
        console.error("getFieldWorkOrderDetailsLPdf error:", error);
        // swal("Failed", "Something went wrong please check your internet", "error");
      } finally {
        setisLoaded(false);
      }
    }
  };

  // ========== Search ==========
  const clearSearch = () => {
    setSearchDispenserSerialNumber("");
    setSearchPerformed(false);
    // reload default list
    getCalibration();
  };

  const search = async () => {
    setSearchPerformed(true);

    if (!searchDispenserSerialNumber) {
      swal("Missing Serial Number", "Please enter the dispenser serial number", "warning").then(() => {
        clearSearch();
      });
      return;
    }

    try {
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      const jobType = ["calibration"];

      const result = await getcalibrationdispensersereialNo(currentPage, searchDispenserSerialNumber, headers, jobType);

      // result could be array or {data: [...]}
      const data = Array.isArray(result) ? result : (result?.data || result?.data?.content || []);

      if (Array.isArray(data) && data.length > 0) {
        // when search we can start ids from 1 (offset 0)
        const updated = addSerialNumbers(data, 0);
        setEntries(updated);
        setPageCount(1);
        setTotalCount(data.length);
        setTotaloffset(0);
      } else {
        swal("No Data", "No records found for the given serial number", "info");
        setEntries([]);
        setPageCount(0);
        setTotalCount(0);
        setTotaloffset(0);
      }
    } catch (error) {
      console.error("Search error:", error);
      swal("Failed", "Failed to fetch data, please try again", "error");
    }
  };

  // ========== Columns ==========
  const columns = [
    { dataField: "id", text: "Id" },
    {
      dataField: "status",
      text: "Calibration Wo Status",
      editable: false,
      headerAlign: "center",
      style: {
        textTransform: "capitalize",
        textAlign: "center",
      },
    },
    {
      dataField: "workOrderSerialNo",
      text: "Calibartion WO Sr No",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "generateUniqueDispenserNo",
      text: "Dispenser Sr No",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "workOrderDate",
      text: "Wo created on",
      editable: false,
      headerAlign: "left",
      formatter: (cell) => <>{moment(cell).format("DD-MMM-YYYY")}</>,
    },
    {
      dataField: "workOrderTime",
      text: "Wo Created time",
      editable: false,
      headerAlign: "left",
      formatter: (cell) => <>{moment(cell, "hh:mm A").format("hh:mm A")}</>,
    },
    {
      dataField: "dispenserType",
      text: "Dispenser Config",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "customerName",
      text: "Customer Name",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "serviceEngineerName",
      text: "Field Man Name",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "serviceEngineerMobNo",
      text: "Field Man Mobile No",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "description",
      text: "description",
      editable: false,
      style: { textTransform: "capitalize" },
      formatter: (cell, row) => (
        <div className="tooltip-container">
          <div className="truncated-text">{cell}</div>
          {cell && cell.length > 20 && <span className="tooltip-text">{row.description}</span>}
        </div>
      ),
    },
    {
      dataField: "address",
      text: "Site Address",
      editable: false,
      style: { textTransform: "capitalize" },
      formatter: (cell, row) => (
        <div className="tooltip-container">
          <div className="truncated-text">{cell}</div>
          {cell && cell.length > 20 && <span className="tooltip-text">{row.address}</span>}
        </div>
      ),
    },
    {
      dataField: "email",
      text: "Email",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "siteType",
      text: "Site Type",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "timeTaken",
      text: "Time Taken",
      headerAlign: "left",
    },
    {
      dataField: "whoDidIt",
      text: "calibration wo created by",
      headerAlign: "left",
      style: {
        textTransform: "capitalize",
        textAlign: "center",
      },
    },
  ];

  // custom the pagination total
  const customTotal = (from, to, size) => (
    <div>
      Showing {totaloffset + from} to {totaloffset + to} of {size} entries
    </div>
  );

  // ========== Render ==========
  return (
    <>
      <Formik
        initialValues={{
          firstname: "",
          lastname: "",
          companyname: "",
          mobileno: "",
          selectdesignation: "",
          email: "",
          country: "",
          state: "",
          address: "",
          city: "",
          desc: "",
        }}
        onSubmit={async (values) => {
          console.log(JSON.stringify(values, null, 2));
        }}
      >
        {(formik) => {
          return (
            <>
              <Row>
                <Col md={{ span: 3, order: 1 }} className="mb-3" xs={{ order: 2 }}>
                  <div className="form-group">
                    <label>From Date</label>
                    <DatePicker
                      selected={fromDate}
                      onChange={handleFromDateChange}
                      dateFormat="dd-MMM-yyyy"
                      maxDate={new Date()}
                      className="form-control"
                      placeholderText="DD-MMM-YYYY"
                      showYearDropdown
                      scrollableYearDropdown
                    />
                  </div>
                </Col>

                <Col md={{ span: 3, order: 2 }} className="mb-3" xs={{ order: 3 }}>
                  <div className="form-group">
                    <label>To Date</label>
                    <DatePicker
                      selected={toDate}
                      onChange={handleToDateChange}
                      dateFormat="dd-MMM-yyyy"
                      minDate={fromDate}
                      maxDate={new Date()}
                      className="form-control"
                      placeholderText="DD-MMM-YYYY"
                      showYearDropdown
                      scrollableYearDropdown
                    />
                  </div>
                </Col>

                <Col md={{ span: 3, order: 3 }} className="mb-3" xs={{ order: 4 }}>
                  <button className="btn btn-secondary mt-lg-4" onClick={getCalibrationListByDate} type="button">
                    <FontAwesomeIcon icon={faSearch} className="me-2" />
                    <span>Search By Date</span>
                  </button>
                </Col>

                <Col md={{ span: 3, order: 4 }} className="mt-4" xs={{ order: 1 }}>
                  {/* <div className="newadd" align="right">
                    <Link to="calibration" className="btn btn-secondary">
                      <FontAwesomeIcon icon={faPlus} className="me-2" />
                      <span>Create Calibration WO</span>
                    </Link>
                  </div> */}
                </Col>
              </Row>

              <ToolkitProvider
                keyField="id"
                search={true}
                columns={columns}
                data={entries}
                exportCSV={{ onlyExportFiltered: true, exportAll: false }}
              >
                {({ baseProps, searchProps, csvProps }) => (
                  <Paginator.PaginationProvider
                    pagination={Pagination({
                      custom: true,
                      disablePageTitle: true,
                      alwaysShowAllBtns: true,
                      totalSize: totalCount,
                      paginationTotalRenderer: customTotal,
                      onPageChange: handlePageChange,
                    })}
                  >
                    {({ paginationProps, paginationTableProps }) => (
                      <Card>
                        <Col xs={12} md={6} className="p-2">
                          <h5 className="head ">calibration wo Entry list</h5>
                        </Col>

                        <div className="table-responsive py-2">
                          <Card.Header>
                            <Row>
                              <Col xs={12} md={6} className="py-1 md-3 d-flex ">
                                <input
                                  type="search"
                                  placeholder="Search by dispenser Sr No..."
                                  value={searchDispenserSerialNumber}
                                  onChange={(e) => setSearchDispenserSerialNumber(e.target.value)}
                                  className="form-control-alternative form-control searchinput "
                                  style={{ marginRight: "10px" }}
                                />

                                <button
                                  type="button"
                                  className="btn btn-secondary"
                                  onClick={searchPerformed ? clearSearch : search}
                                >
                                  <FontAwesomeIcon icon={searchPerformed ? faTimes : faSearch} className="me-2" />
                                  <span>{searchPerformed ? "Clear Serial Number" : "Search By Serial Number"}</span>
                                </button>
                              </Col>

                              <Col xs={12} md={6} className="d-flex justify-content-md-end py-1">
                                <button className="btn btn-secondary" onClick={getCalibrationReportPdfDownload}>
                                  <FontAwesomeIcon icon={faDownload} className="me-2" />
                                  <span>PDF</span>
                                </button>

                                <button className="btn btn-secondary mx-2" onClick={getFieldWorkOrderExcel}>
                                  <FontAwesomeIcon icon={faDownload} className="me-2" />
                                  <span>Excel</span>
                                </button>
                              </Col>
                            </Row>
                          </Card.Header>

                          {isLoaded ? (
                            <div className="text-center bg-black text-white"> Please wait calibration data is loading ... </div>
                          ) : (
                            <BootstrapTable
                              {...baseProps}
                              {...paginationTableProps}
                              bodyClasses="border-0"
                              rowClasses="border-bottom"
                              classes="table-flush dataTable-table"
                              wrapperClasses="table-responsive"
                              headerClasses="header-class"
                              hover
                              striped
                              condensed
                              filter={filterFactory()}
                              remote={{ pagination: true }}
                              cellEdit={cellEditFactory({
                                mode: "click",
                                blurToSave: true,
                                afterSaveCell: (oldValue, newValue, row, column) => {
                                  console.log(oldValue, newValue, row, column);
                                },
                              })}
                            />
                          )}

                          <Card.Footer>
                            <Row>
                              <Col xs={12} md={6} className="py-1"></Col>
                              <Col xs={12} md={6} className="d-flex justify-content-md-end align-items-center mb-0 py-1">
                                <Paginator.PaginationListStandalone {...paginationProps} />
                              </Col>
                            </Row>
                          </Card.Footer>
                        </div>
                      </Card>
                    )}
                  </Paginator.PaginationProvider>
                )}
              </ToolkitProvider>
            </>
          );
        }}
      </Formik>
    </>
  );
};
